<template>
  <v-app>
    <v-container class="pa-0">
      <v-row
        class="banner"
        no-gutters
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="5"
        >
          <v-responsive :aspect-ratio="1065/531">
            <v-img :src="store.image"/>
          </v-responsive>
        </v-col>
      </v-row>
      <v-row
        class="mt-n5"
        no-gutters
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="5"
        >
          <v-card
            rounded="xl"
            elevation="8"
            min-height="100vh"
          >
            <v-card-title
              class="font-weight-bold"
            >
              <v-container>
                <v-row>
                  <v-col
                    cols="3"
                  >
                    <v-avatar size="100%">
                      <v-img :src="brand.logo"/>
                    </v-avatar>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div>{{ brand.name }}</div>
                    <div>{{ store.name }}</div>
                    <div
                      class="my-2 text-caption text--secondary"
                    >{{ store.tel }}・{{ store.address }}</div>
                    <div>
                      <v-btn
                        depressed
                        rounded
                        :to="{ name: 'Brand' }"
                        class="mr-2 my-2"
                        exact
                      >
                        <v-icon left>mdi-store</v-icon>
                        其他分店
                      </v-btn>
                      <v-btn
                        depressed
                        rounded
                        :href="`tel:${store.tel}`"
                        class="mr-2 my-2"
                      >
                        <v-icon left>mdi-phone</v-icon>
                        撥打電話
                      </v-btn>
                      <v-btn
                        depressed
                        rounded
                        :href="`https://maps.google.com/?q=${store.address}`"
                        target="_blank"
                        class="mr-2 my-2"
                      >
                        <v-icon left>mdi-map-marker</v-icon>
                        地圖
                      </v-btn>
                    </div>
                    <div
                      class="mt-4 text-body-2 grey--text text--darken-1"
                      v-if="store.welcome"
                    >
                      <vue-markdown :source="store.welcome" :options="{ linkify: true }"/>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-title>

            <div
              class="pa-4"
            >
              <div
                class="font-weight-bold mb-4"
              >
                預約服務項目
              </div>
              <v-container
                class="px-0 rounded-xl"
              >
                <v-row>
                  <v-col
                    cols="6"
                    v-for="service in services"
                    v-bind:key="service.token"
                    v-on:click="onClickService(service)"
                  >
                    <v-sheet>
                      <v-img
                        class="rounded-lg mb-2"
                        :src="service.image"
                      />
                      <div>
                        <div class="font-weight-bold">
                          {{ service.name }}
                        </div>
                        <div class="d-flex align-center text--secondary">
                          <v-icon
                            class="mr-1"
                            small
                          >mdi-timer-outline</v-icon>
                          {{ service.duration }} 分鐘
                        </div>
                      </div>
                    </v-sheet>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="5"
        >
          <div class="my-4 text-center text-caption text--secondary">
            bookNow.tw ©️ All Rights Reserved.<br>
            <span v-if="brand.name">{{ brand.name }}</span>
            <span v-else>品牌</span>
            保留接受或拒絕預訂之權力
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
      v-model="serviceDialog"
      fullscreen
      hide-overlay
      scrollable
      transition="dialog-bottom-transition"
      ref="dialog"
    >
      <v-card
        rounded="0"
      >
        <v-toolbar
          dark
          color="pink"
          elevation="0"
          class="flex-grow-0"
        >
          <v-btn
            icon
            dark
            v-on:click="clearService"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title class="font-weight-bold">{{ service.name }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="px-0">
          <v-container class="pa-0">
            <v-row
              no-gutters
              justify="center"
            >
              <v-col
                cols="12"
                sm="8"
                md="6"
                lg="5"
              >
                <v-stepper
                  v-model="serviceStep"
                  class="elevation-0"
                >
                  <v-stepper-items>
                    <v-stepper-content
                      step="1"
                      class="pa-0"
                    >
                      <v-img
                        class="rounded-0"
                        :src="service.image"
                      />
                      <div class="pa-4">
                        <div class="mb-4">
                          <div class="text-h6 grey--text text--darken-4 font-weight-bold">
                            {{ service.name }}
                          </div>
                          <div class="d-flex align-center text--secondary">
                            <v-icon
                              class="mr-1"
                              small
                            >mdi-timer-outline</v-icon>
                            {{ service.duration }} 分鐘
                          </div>
                        </div>
                        <vue-markdown class="markdown-textview" :source="service.desc" :options="{ linkify: true }"/>
                        <vue-markdown class="markdown-textview" :source="service.comment" :options="{ linkify: true }"/>

                        <v-form
                          v-if="service.fields"
                          v-model="serviceFieldsValid"
                        >
                          <v-container class="px-0">
                            <v-row
                              dense
                              v-for="field in service.fields"
                              v-bind:key="field.token"
                            >
                              <v-col
                                v-if="field.type === 'CHECKBOX'"
                              >
                                <v-checkbox
                                  color="pink"
                                  v-model="serviceOptions.fields[field.token]"
                                  :value="field.field"
                                  :label="field.field"
                                  :rules="field.required ? requiredRules : null"
                                  dense
                                  hide-details="auto"
                                />
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-form>
                      </div>
                    </v-stepper-content>

                    <v-stepper-content
                      step="2"
                      class="pa-0"
                    >
                      <div
                        class="pa-6 pink lighten-5 rounded-b-xl"
                      >
                        <template v-if="service.staff && service.staff.length > 0">
                          <div
                            class="text-caption pink--text font-weight-bold"
                          >選擇服務人員</div>
                          <v-container
                            class="px-0 mb-4"
                            v-if="selectedStaff"
                          >
                            <v-row class="d-block text-no-wrap overflow-x-auto">
                              <v-col
                                cols="3"
                                class="staff-item d-inline-block"
                                v-for="staff in service.staff"
                                v-bind:key="staff.token"
                                v-on:click="onClickStaff(staff.token)"
                              >
                                <v-img
                                  :src="staff.image"
                                  aspect-ratio="1"
                                  class="staff-avatar white rounded-circle mb-2"
                                  :class="{ 'is-selected': staff.token === selectedStaff }"
                                  v-if="staff.image"
                                />
                                <v-responsive
                                  class="staff-avatar pink lighten-2 rounded-circle"
                                  :class="{ 'is-selected': staff.token === selectedStaff }"
                                  :aspect-ratio="1"
                                  v-else
                                >
                                  <v-avatar
                                    color="pink"
                                    size="100%"
                                  >
                                    <span class="text-center white--text text-h5 text-truncate">{{ staff.name.charAt(0) }}</span>
                                  </v-avatar>
                                </v-responsive>
                                <div
                                  class="mt-1 grey--text font-weight-bold text-center text-truncate"
                                  :class="{ 'text--darken-4': staff.token === selectedStaff }"
                                >
                                  {{ staff.name }}
                                </div>
                              </v-col>
                            </v-row>
                          </v-container>
                          <v-container
                            class="px-0 mb-4"
                            v-else
                          >
                            <v-row>
                              <v-col
                                cols="4"
                                v-for="staff in service.staff"
                                v-bind:key="staff.token"
                                v-on:click="onClickStaff(staff.token)"
                              >
                                <v-img
                                  :src="staff.image"
                                  aspect-ratio="1"
                                  class="white rounded-lg"
                                  v-if="staff.image"
                                />
                                <v-responsive
                                  class="pink rounded-lg"
                                  :aspect-ratio="1"
                                  v-else
                                >
                                  <v-avatar
                                    class="staff-avatar"
                                    color="pink"
                                    size="100%"
                                  >
                                    <span class="white--text text-h5">{{ staff.name.charAt(0) }}</span>
                                  </v-avatar>
                                </v-responsive>
                                <div class="mt-1 grey--text text--darken-4 font-weight-bold">
                                  {{ staff.name }}
                                </div>
                                <div
                                  class="align-center text--secondary"
                                  v-if="staff.desc"
                                >
                                  {{ staff.desc }}
                                </div>
                              </v-col>
                            </v-row>
                          </v-container>
                        </template>
                        <div
                          class="text-caption pink--text font-weight-bold"
                        >選擇日期與人數</div>
                        <div
                          class="text-caption text--secondary"
                        >若日期反灰無法選擇，代表當日預約已滿或當日未開放預約</div>
                        <v-container class="px-0">
                          <v-row>
                            <v-col>
                              <v-menu
                                v-model="datePickerMenu"
                                :close-on-content-click="false"
                                min-width="auto"
                                rounded="lg"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    :items="serviceOptions.date"
                                    prepend-icon="mdi-calendar"
                                    :value="formatedSelectedDate"
                                    label="日期"
                                    v-bind="attrs"
                                    v-on="on"
                                    color="pink"
                                    readonly
                                    hide-details
                                  />
                                </template>
                                <v-date-picker
                                  v-model="selectedDate"
                                  :min="serviceOptions.minDate"
                                  :max="serviceOptions.maxDate"
                                  :allowed-dates="allowDates"
                                  color="pink"
                                  no-title
                                  v-on:input="datePickerMenu = false"
                                  :day-format="dayFormatter"
                                />
                              </v-menu>
                            </v-col>
                            <v-col>
                              <v-select
                                :items="serviceOptions.amount"
                                item-color="pink"
                                v-model="selectedAmount"
                                prepend-icon="mdi-account"
                                label="人數"
                                color="pink"
                                hide-details
                              ></v-select>
                            </v-col>
                          </v-row>
                        </v-container>

                        <v-slide-y-transition>
                          <div v-if="selectedDate && selectedAmount">
                            <div
                              class="mt-4 text-caption pink--text font-weight-bold"
                            >選擇預約時間</div>
                            <v-container class="px-0">
                              <v-row>
                                <v-col>
                                  <template
                                    v-if="isServiceTimeLoading"
                                  >
                                    <v-skeleton-loader type="chip"/>
                                  </template>
                                  <template v-else>
                                    <template
                                      v-if="serviceOptions.time.length === 0"
                                    >
                                      <div
                                        class="mt-4 text-center text-caption font-weight-bold"
                                      >無可預約的時間，請選擇其他日期、人數！</div>
                                    </template>
                                    <template v-else>
                                      <v-chip-group
                                        v-model="selectedTime"
                                        active-class="font-weight-bold pink white--text"
                                        column
                                      >
                                        <v-chip
                                          class="white"
                                          v-for="slot in serviceOptions.time"
                                          v-bind:key="slot"
                                          :value="slot"
                                          filter
                                        >
                                          {{ slot }}
                                        </v-chip>
                                      </v-chip-group>
                                    </template>
                                  </template>
                                </v-col>
                              </v-row>
                            </v-container>
                          </div>
                        </v-slide-y-transition>
                      </div>

                      <v-slide-y-transition>
                        <div
                          class="mt-4 pa-4"
                          v-if="selectedDate && selectedAmount && selectedTime"
                        >
                          <div
                            class="text-center mb-4"
                          >
                            <div
                              class="text-caption pink--text font-weight-bold"
                            >填寫預約資料</div>
                            <div class="mb-2 text-h6 font-weight-bold">{{ brand.name }} - {{ store.name }}</div>
                            <div>{{ service.name }}</div>
                            <div>{{ selectedDate | moment('M/D (ddd)') }} {{ selectedTime }}・{{ selectedAmount }} 位</div>
                          </div>
                          <v-form
                            v-model="valid"
                          >
                            <v-container class="px-0">
                              <v-row>
                                <v-col>
                                  <v-text-field
                                    filled
                                    rounded
                                    dense
                                    label="姓名*"
                                    color="pink"
                                    prepend-icon="mdi-account"
                                    v-model.trim="name"
                                    :rules="nameRules"
                                    hide-details="auto"
                                  />
                                </v-col>
                                <v-col>
                                  <v-select
                                    filled
                                    rounded
                                    dense
                                    label="性別*"
                                    :items="[{ text: '男', value: 'male' }, { text: '女', value: 'female' }]"
                                    item-color="pink"
                                    prepend-icon="mdi-human-male-female"
                                    color="pink"
                                    v-model.trim="gender"
                                    :rules="genderRules"
                                    hide-details="auto"
                                  />
                                </v-col>
                              </v-row>
                              <v-row dense>
                                <v-col>
                                  <v-text-field
                                    type="tel"
                                    filled
                                    rounded
                                    dense
                                    label="手機號碼*"
                                    color="pink"
                                    prepend-icon="mdi-phone"
                                    v-model.trim="cell"
                                    :rules="cellRules"
                                    hide-details="auto"
                                  />
                                </v-col>
                              </v-row>
                              <v-row dense>
                                <v-col>
                                  <v-text-field
                                    type="email"
                                    filled
                                    rounded
                                    dense
                                    label="Email"
                                    color="pink"
                                    prepend-icon="mdi-email"
                                    v-model.trim="email"
                                    :rules="emailRules"
                                    hide-details="auto"
                                  />
                                </v-col>
                              </v-row>
                              <v-row dense
                                v-if="serviceOptions.purposes.length > 0"
                              >
                                <v-col>
                                  <v-select
                                    filled
                                    rounded
                                    dense
                                    label="預約目的"
                                    :items="serviceOptions.purposes"
                                    item-color="pink"
                                    prepend-icon="mdi-format-list-bulleted-type"
                                    color="pink"
                                    v-model="purpose"
                                    multiple
                                    hide-details="auto"
                                  />
                                </v-col>
                              </v-row>
                              <v-row
                                v-for="field in service.fields"
                                v-bind:key="field.token"
                                dense
                              >
                                <v-col v-if="field.type === 'TEXT'">
                                  <v-text-field
                                    filled
                                    rounded
                                    dense
                                    prepend-icon="mdi-playlist-edit"
                                    color="pink"
                                    :label="field.required ? `${field.field}*` : field.field"
                                    :hint="field.placeholder || null"
                                    :rules="validePattern(field.required, field.pattern)"
                                    v-model.trim="serviceOptions.fields[field.token]"
                                    hide-details="auto"
                                  />
                                </v-col>
                                <v-col v-else-if="field.type === 'SELECT'">
                                  <v-select
                                    filled
                                    rounded
                                    dense
                                    prepend-icon="mdi-text-box"
                                    item-color="pink"
                                    color="pink"
                                    :items="field.options"
                                    :label="field.required ? `${field.field}*` : field.field"
                                    :rules="validePattern(field.required, field.pattern)"
                                    v-model.trim="serviceOptions.fields[field.token]"
                                    :multiple="field.multiple"
                                    hide-details="auto"
                                  />
                                </v-col>
                              </v-row>
                              <v-row dense>
                                <v-col>
                                  <v-textarea
                                    filled
                                    rounded
                                    dense
                                    label="備註"
                                    prepend-icon="mdi-comment"
                                    color="pink"
                                    v-model.trim="comment"
                                    multiple
                                    rows="2"
                                    hide-details="auto"
                                  />
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-form>
                        </div>
                      </v-slide-y-transition>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-container class="px-0">
            <v-row
              no-gutters
              justify="center"
            >
              <v-col
                cols="12"
                sm="8"
                md="6"
                lg="5"
              >
                <template
                  v-if="serviceStep === 1"
                >
                  <v-container class="pa-0">
                    <v-row
                      dense
                    >
                      <v-col>
                        <v-btn
                          depressed
                          block
                          rounded
                          color="pink"
                          v-on:click="serviceStep = 2"
                          :disabled="service.fields && !serviceFieldsValid"
                          class="white--text"
                        >
                          bookNow!
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </template>

                <template
                  v-if="serviceStep === 2"
                >
                  <v-container class="pa-0">
                    <v-row
                      dense
                    >
                      <v-col
                        cols="auto"
                      >
                        <v-btn
                          depressed
                          rounded
                          block
                          color="pink"
                          v-on:click="resetServiceStep"
                          class="white--text"
                        >
                          上一步
                        </v-btn>
                      </v-col>
                      <v-col>
                        <v-btn
                          depressed
                          rounded
                          block
                          color="pink"
                          v-on:click="submitBook"
                          class="white--text"
                          :disabled="isSubmitDisabled"
                          :loading="isSubmitting"
                        >
                          送出
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </template>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Axios from '@/helpers/axios';
import VueMarkdown from 'vue-markdown-render';
import PhoneNumber from 'awesome-phonenumber';
import {
  initTracking, trackEvent, trackLineConversion, itemId, EVENTS, ITEM_TYPE,
} from '@/helpers/tracking';

export default {
  name: 'Store',
  components: {
    VueMarkdown,
  },
  beforeMount() {
    const data = {
      brandId: this.$route.params.brandId,
      storeId: this.$route.params.storeId,
    };

    Axios({
      method: 'POST',
      url: 'store',
      data,
    })
      .then((api) => {
        if (api.status === 200) {
          this.brand = api.data.brand;
          this.store = api.data.store;
          this.services = api.data.services;

          initTracking(api.data.tracking);
          trackEvent(EVENTS.VIEW_STORE, {
            ga: {
              items: [
                this.trackingItem(
                  api.data.store.name, this.$route.params.storeId, ITEM_TYPE.STORE,
                ),
              ],
            },
            pixel: {
              content_type: 'product',
              content_ids: [this.trackingItemId(api.data.store.name, this.$route.params.storeId)],
              content_name: api.data.store.name,
              content_category: api.data.store.name,
            },
          });

          // 服務清單曝光。這是 select_item 的分母，有了它才能算服務的點擊率
          trackEvent(EVENTS.VIEW_SERVICE_LIST, {
            ga: {
              item_list_id: this.$route.params.storeId,
              item_list_name: api.data.store.name,
              items: api.data.services.map((service, index) => ({
                ...this.trackingItem(service.name, service.token, ITEM_TYPE.SERVICE),
                index,
              })),
            },
          });
        }
      });
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,

      serviceStep: 1,
      serviceDialog: false,
      datePickerMenu: false,
      nameRules: [
        (input) => !!input.trim() || '必填項目',
      ],
      cellRules: [
        (input) => !!input.trim() || '必填項目',
        () => {
          if (this.cellInstance.isValid()) return true;
          return '不正確的電話格式';
        },
      ],
      genderRules: [
        (input) => !!input || '必填項目',
      ],
      emailRules: [
        (input) => input === '' || /.+@.+\..+/.test(input.trim()) || '格式不正確',
      ],
      requiredRules: [
        (input) => !!input || '必填項目',
      ],
      isSubmitting: false,

      brand: {
        name: '',
        logo: '',
        image: '',
      },

      store: {
        token: '',
        name: '',
        image: '',
        address: '',
        tel: '',
        welcome: '',
      },

      services: [],

      service: {
        comment: '',
        desc: '',
        duration: 0,
        image: '',
        name: '',
        token: '',
        fields: [],
      },
      isServiceTimeLoading: false,
      serviceFieldsValid: false,

      serviceOptions: {
        minDate: '',
        maxDate: '',
        disableDate: [],
        amount: [],
        time: [],
        purposes: [],
      },

      selectedStaff: null,
      selectedDate: null,
      selectedAmount: null,
      selectedTime: null,
      name: '',
      cell: '',
      gender: '',
      email: '',
      purpose: '',
      comment: '',
      valid: false,
    };
  },
  computed: {
    formatedSelectedDate() {
      if (this.selectedDate === null) return null;
      return this.$moment(this.selectedDate).format('M/D (ddd)');
    },
    cellInstance() {
      return new PhoneNumber(this.cell, 'TW');
    },
    isSubmitDisabled() {
      return !(this.selectedDate && this.selectedAmount && this.selectedTime && this.valid);
    },
  },
  methods: {
    trackingItemId(name, token) {
      return itemId(this.$route.params.brandId, name, token);
    },
    // 組出 GA4 的 item 物件。item_brand／item_category 是 GA4 內建的商品維度，
    // 有了它們就能在報表用正規維度依品牌與分店切分，不必去解析 item_id 字串。
    // item_category 一律放分店名（分店本身的 view_item 也照放，維持一致），
    // item_category2 放項目類型，用來在同一份報表裡區分分店與服務。
    trackingItem(name, token, type, quantity) {
      const item = {
        item_id: this.trackingItemId(name, token),
        item_name: name,
        item_brand: this.brand.name,
        item_category: this.store.name,
        item_category2: type,
      };
      if (quantity) item.quantity = quantity;

      return item;
    },
    onClickService(service) {
      this.service = service;

      // 點開服務詳情，與品牌頁的 view_item_list 配成一對，
      // 可算出「看到服務 -> 點開服務」的轉換率
      trackEvent(EVENTS.SELECT_SERVICE, {
        ga: {
          item_list_id: this.$route.params.storeId,
          item_list_name: this.store.name,
          items: [
            this.trackingItem(service.name, service.token, ITEM_TYPE.SERVICE),
          ],
        },
      });

      // 點開詳情等同於查看商品，服務因此才有瀏覽數可算「瀏覽 -> 預約」轉換率
      trackEvent(EVENTS.VIEW_SERVICE, {
        ga: {
          items: [
            this.trackingItem(service.name, service.token, ITEM_TYPE.SERVICE),
          ],
        },
      });
      if ('fields' in this.service) {
        this.$set(this.serviceOptions, 'fields', {});
        this.service.fields.forEach((field) => {
          this.$set(this.serviceOptions.fields, field.token, null);
        });
      }
      if (this.service.staff && this.service.staff.length === 1) this.selectedStaff = this.service.staff[0].token;
      this.serviceDialog = true;
    },
    clearService() {
      this.serviceStep = 1;
      this.resetForm();
      this.serviceDialog = false;
      this.service = {
        comment: '',
        desc: '',
        duration: 0,
        image: '',
        name: '',
        token: '',
      };
    },
    initServiceDetail() {
      const data = {
        brandId: this.$route.params.brandId,
        storeId: this.$route.params.storeId,
        serviceId: this.service.token,
      };

      Axios({
        method: 'POST',
        url: 'schedule',
        data,
      })
        .then((api) => {
          if (api.status === 200) {
            this.serviceOptions.amount = [];

            this.serviceOptions.minDate = api.data.startDate;
            this.serviceOptions.maxDate = api.data.endDate;
            this.serviceOptions.disableDate = api.data.disableDate;

            Array.from(Array(api.data.maxAmount).keys()).forEach((item, index) => {
              this.serviceOptions.amount.push({
                text: `${index + 1} 位`,
                value: index + 1,
              });
            });

            if ('amount' in api.data) this.selectedAmount = api.data.amount;
            if ('purposes' in api.data) this.serviceOptions.purposes = api.data.purposes;
          }
        });
    },
    onClickStaff(token) {
      this.selectedStaff = token;
    },
    allowDates(date) {
      if (this.serviceOptions.disableDate.includes(date)) return false;
      return true;
    },
    getServiceTime() {
      this.serviceOptions.time = [];

      const data = {
        brandId: this.$route.params.brandId,
        storeId: this.$route.params.storeId,
        serviceId: this.service.token,
        date: this.selectedDate,
        amount: this.selectedAmount,
      };

      if (this.selectedStaff) data.staffId = this.selectedStaff;

      this.isServiceTimeLoading = true;

      Axios({
        method: 'POST',
        url: 'schedule',
        data,
      })
        .then((api) => {
          if (api.status === 200) {
            this.serviceOptions.time = api.data.availableTime;
          }

          this.isServiceTimeLoading = false;
        })
        .catch(() => {
          this.isServiceTimeLoading = false;
        });
    },
    dayFormatter(date) {
      return parseInt(date.slice(-2), 10);
    },
    resetServiceStep() {
      this.serviceStep = 1;
      this.resetForm();
    },
    resetForm() {
      this.selectedStaff = null;
      this.selectedDate = null;
      this.selectedAmount = null;
      this.selectedTime = null;
      this.name = '';
      this.cell = '';
      this.gender = '';
      this.email = '';
      this.purpose = '';
      this.comment = '';
      this.valid = true;
      this.loadLastContact();
    },
    loadLastContact() {
      try {
        const lastContact = JSON.parse(localStorage.getItem('booknow_last_contact'));
        if (!lastContact) return;
        this.name = lastContact.name || '';
        this.gender = lastContact.gender || '';
        this.cell = lastContact.cell || '';
        this.email = lastContact.email || '';
      } catch (e) {
        // localStorage 不可用或資料損毀時略過
      }
    },
    saveLastContact() {
      try {
        localStorage.setItem('booknow_last_contact', JSON.stringify({
          name: this.name,
          gender: this.gender,
          cell: this.cell,
          email: this.email,
        }));
      } catch (e) {
        // localStorage 不可用時略過
      }
    },
    validePattern(required, pattern) {
      const rules = [];

      if (required) rules.push((input) => !!input || '必填項目');

      if (pattern) rules.push((input) => new RegExp(pattern).test(input));

      return rules;
    },
    submitBook() {
      const data = {
        brandId: this.$route.params.brandId,
        storeId: this.$route.params.storeId,
        serviceId: this.service.token,
        date: this.selectedDate,
        amount: this.selectedAmount,
        time: this.selectedTime,
        name: this.name,
        contact: this.cellInstance.getNumber(),
        gender: this.gender,
        email: this.email,
        comment: this.comment,
      };

      if (this.serviceOptions.purposes.length > 0) data.purpose = this.purpose;

      if ('fields' in this.serviceOptions) data.fields = this.serviceOptions.fields;

      if (this.selectedStaff) data.staffId = this.selectedStaff;

      this.isSubmitting = true;

      Axios({
        method: 'POST',
        url: 'create',
        data,
      })
        .then((api) => {
          if (api.status === 200) {
            this.saveLastContact();

            // 預約成功是最關鍵的轉換點。transaction_id / eventID 用純 token，
            // 之後若接 Meta CAPI 需要兩邊的去重鍵完全一致
            trackEvent(EVENTS.BOOK_SUCCESS, {
              ga: {
                transaction_id: api.data.token,
                // 預約沒有金額，但 GA4 的 purchase 需要這兩個才會正確處理
                value: 0,
                currency: 'TWD',
                items: [
                  this.trackingItem(
                    this.service.name, this.service.token,
                    ITEM_TYPE.SERVICE, this.selectedAmount,
                  ),
                ],
              },
              pixel: {
                content_type: 'product',
                content_ids: [this.trackingItemId(this.service.name, this.service.token)],
                content_name: this.service.name,
                content_category: this.store.name,
                num_items: this.selectedAmount,
              },
              eventId: api.data.token,
            });
            trackLineConversion();

            this.$router.push({ name: 'Booked', params: { bookId: api.data.token } });
            this.isSubmitting = false;
          }
        })
        .catch(() => {
          this.isSubmitting = false;
        });
    },
  },
  created() {
    this.loadLastContact();
  },
  watch: {
    serviceStep(newValue, oldValue) {
      if (newValue === 2 && oldValue === 1) {
        this.initServiceDetail();

        // 進入選時段這一步視為開始預約
        trackEvent(EVENTS.BEGIN_BOOK, {
          ga: {
            items: [
              this.trackingItem(this.service.name, this.service.token, ITEM_TYPE.SERVICE),
            ],
          },
          pixel: {
            content_type: 'product',
            content_ids: [this.trackingItemId(this.service.name, this.service.token)],
            content_name: this.service.name,
            content_category: this.store.name,
          },
        });
      }
    },
    selectedStaff() {
      this.selectedTime = null;
      if (this.selectedDate && this.selectedAmount) this.getServiceTime();
    },
    selectedDate() {
      this.selectedTime = null;
      if (this.selectedDate && this.selectedAmount) this.getServiceTime();
    },
    selectedAmount() {
      this.selectedTime = null;
      if (this.selectedDate && this.selectedAmount) this.getServiceTime();
    },
  },
};
</script>

<style lang="sass" scoped>
.banner
  position: sticky
  top: 0

.staff-item
  max-width: 22%
  width: 22%
  min-width: 75px

  cursor: pointer

.staff-avatar
  &.is-selected
    box-shadow: 0 0 0 2px #fce4ec, 0 0 0 4px #e91e63
</style>
